import { createStyles, palette } from "../../../styles/theme";

export const specsEditorFieldStyles = createStyles({
  specsMultiAutocompletePreview: {
    width: "100%",
    minHeight: 38,
    px: 1.5,
    py: 1,
    borderRadius: "6px",
    border: `1px solid ${palette.grey.lightGrey}`,
    bgcolor: "common.white",
    cursor: "text",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: 14,
    lineHeight: 1.4,
    "&:hover": {
      borderColor: palette.grey.darkGrey,
    },
  },
  specsMultiAutocompleteError: {
    border: `1px solid ${palette.red.error}`,
    borderRadius: "6px",
    bgcolor: palette.misc.errorBg,
    px: 1,
    py: 0.25,
  },
});

export const INHERITED_COLOR_LABEL = "Inherit";
